import { render, staticRenderFns } from "./ResultadoPagoOT.vue?vue&type=template&id=a84915a8&scoped=true&lang=pug"
import script from "./ResultadoPagoOT.vue?vue&type=script&lang=js"
export * from "./ResultadoPagoOT.vue?vue&type=script&lang=js"
import style0 from "./ResultadoPagoOT.vue?vue&type=style&index=0&id=a84915a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84915a8",
  null
  
)

export default component.exports